import compact from 'lodash/compact'
import map from 'lodash/map'
import React, { FC } from 'react'

import { CategoryListV2 } from '@Blocks/CategoryListBlock/CategoryList'
import { BlockContainer } from '@Components/BlockContainer'
import { Block } from '@Generated/graphql'
import { getNavigationFieldItems } from '@Globals/CMS/FieldHelpers'

import styles from './CategoryListBlock.module.scss'

interface CategoryListBlockProps {
  categoryListBlock: Block
  id?: string
}

const CategoryListBlock: FC<CategoryListBlockProps> = ({ categoryListBlock, id }) => {
  const navigationItems = getNavigationFieldItems(categoryListBlock?.fields || [], 'navigation')
  if (!navigationItems || navigationItems.length === 0) {
    return null
  }

  const { appearance, common } = categoryListBlock

  return (
    <BlockContainer
      appearance={appearance || {}}
      center
      className={styles.categoryListBlockRedesign}
      common={common || {}}
      id={id}
    >
      <CategoryListV2
        backgroundColor={appearance?.backgroundColor || ''}
        items={compact(map(navigationItems, (item) => {
          if (!item?.link?.url) {
            return null
          }

          const ref = item.link.references?.[0]
          if (!ref || ref.__typename !== 'Page' || !ref.id || !ref.type) {
            return null
          }

          return {
            id: ref.id,
            link: item.link?.url,
            name: item.title || ref.title || '',
            newTab: false,
            type: ref.type,
          }
        }))}
        textColor={appearance?.textColor || ''}
      />
    </BlockContainer>
  )
}

export default CategoryListBlock
